"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.creditNoteMoneyMapping = void 0;
exports.creditNoteMoneyMapping = {
    amount: "amountScaled",
    usedAmount: "usedAmountScaled",
};
